import React, {useEffect, useState} from 'react';

export type UpdateIntervalEnhancerProps = {
  tickIndex: number;
};

export default function updateIntervalEnhancer<P>(
  WrappedComponent: React.ComponentType<P & UpdateIntervalEnhancerProps>,
  interval: number
) {
  /*
    This enhancer ensure WrappedComponent is re-rendered each
    [interval] milliseconds sending a updated 'tickIndex' prop with
    current unix time value.
    */
  return (props: P) => {
    const [timer, setTimer] = useState<number>();
    const [tick, setTick] = useState<number>(0);
    const advanceTick = () => {
      setTick((prevTick) => prevTick + 1);
    };
    useEffect(() => {
      setTimer(window.setInterval(advanceTick, interval));

      return () => {
        if (timer != null) {
          clearInterval(timer);
        }
      };
    }, []);
    return <WrappedComponent tickIndex={tick} {...props} />;
  };
}
